import SpinnerWrapper from "@arelia-components/ui-atoms/SpinnerWrapper";
import { DeepPartial } from "@arelia-types/index";
import { mergeWith } from "lodash";
import { useParams } from "react-router-dom";
import { useCustomersDetailsAPI, useHqCustomersUpdateMutation } from "../hq-customers.api";
import { CustomerDetails } from "../models";
import { CustomerDetailsPresenter } from "./CustomerDetailsPresenter";

export default function CustomerDetailsContainer() {
  const { id } = useParams();
  const { data: customerDetails, isLoading } = useCustomersDetailsAPI(id as string);
  const updateMutation = useHqCustomersUpdateMutation();

  const updateCustomer = (cutomerUpdates: DeepPartial<CustomerDetails>) => {
    const updatedCustomer = mergeWith({}, customerDetails, cutomerUpdates, (_, srcValue, key) => {
      if (key === 'members') {
        return srcValue;
      }
    });
    updateMutation.mutate(updatedCustomer);
  };

  return (
    <SpinnerWrapper loading={isLoading}>
      {customerDetails &&
        <CustomerDetailsPresenter
          customerDetails={customerDetails}
          updateCustomer={updateCustomer}
        ></CustomerDetailsPresenter>
      }
    </SpinnerWrapper>
  );
}
